<template>
	<div class="inline-select-view">
		<div @click.stop="presenting = !presenting;" style="width: 100%; height: 100%; color: black;">{{ _selected.label }}</div>
		<div class="options" v-if="presenting">
			<div v-for="(opt, i) in options" :key="i">
				<div v-if="opt !== null" class="option" @click.stop="$emit('input', opt.value); presenting = false;">
					<span class="leveled">{{ opt.label }}</span>
				</div>
				<div v-if="opt === null" class="separator"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['options', 'value'],
		data() {
			return {
				presenting: false
			};
		},
		computed: {
			_selected() {
				for (var key in this.options) {
					if (this.value == this.options[key].value) {
						return this.options[key];
					}
				}

				return {
					label: '',
					value: null
				};
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.inline-select-view {
		position: relative;
		cursor: pointer;

		& > .options {
			position: absolute;
			left: 0;
			top: 40px;
			background-color: white;
			min-width: 100%;
			max-height: 350px;
			overflow-y: auto;
			z-index: 10000;

			-webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			-moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);

			& > div {
				& > .option {
					padding: 10px 20px 10px 15px;
					position: relative;

					& .buttons {
						position: absolute;
						top: 11px;
						right: 10px;

						& > .button {
							float: right;
							margin-left: 10px;
							fill: rgb(177, 177, 177);

							&.add {
								transform: scale(0.8);
							}
						}
					}

					&:hover {
						background-color: #F5F5F5;
					}
				}

				& > .separator {
					height: 1px;
					background-color: #d6d6d6;
					cursor: default;
				}
			}
		}
	}
</style>